var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 157,
    viewBox: "0 0 152 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.0454 48.308L150.79 35.7488V129.952L89.0454 155.859V48.308Z",
    fill: "#9BDDFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0454 48.308L150.79 35.7488V129.952L89.0454 155.859V48.308Z",
    stroke: "#0C7BAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0458 48.5001L75.4998 45.0001L27.7332 62.0001V124.902L89.0458 155.859V48.5001Z",
    fill: "#059BD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0458 48.5001L75.4998 45.0001L27.7332 62.0001V124.902L89.0458 155.859V48.5001Z",
    stroke: "#0C7BAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 45L89.0457 48.308L150.79 35.7489L97.5 32.5L86.4173 39.2406L75.5 45Z",
    fill: "#0C7BAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 45L89.0457 48.308L150.79 35.7489L97.5 32.5L86.4173 39.2406L75.5 45Z",
    stroke: "#0C7BAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5478 45.7174L121.805 17.1073L114.502 1L68.2263 29.5913L75.5478 45.7174Z",
    fill: "#9BDDFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5478 45.7174L121.805 17.1073L114.502 1L68.2263 29.5913L75.5478 45.7174Z",
    stroke: "#0C7BAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 52.4756L40.123 27.1133L114.502 1L68.2262 29.5913L1 52.4756Z",
    fill: "#9BDDFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 52.4756L40.123 27.1133L114.502 1L68.2262 29.5913L1 52.4756Z",
    stroke: "#0C7BAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5477 45.7174L8.3027 68.5829L1 52.4756L68.2262 29.5913L75.5477 45.7174Z",
    fill: "#059BD2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5477 45.7174L8.3027 68.5829L1 52.4756L68.2262 29.5913L75.5477 45.7174Z",
    stroke: "#0C7BAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.56111aad90656880dc3f5874445b9aeb.svg";
export { ForwardRef as ReactComponent };